import { ComponentMetadataModel, ParameterMetadata, ParameterType, PrimitiveType } from '../../../api/api';
import { ParameterTypes } from '@@common';


export const DialogActionParameters: ParameterMetadata[] = [
    {
        name: 'Label',
        displayName: 'Label',
        order: 1,
        type: ParameterType.Primitive,
        description: 'The text displayed on the button',
        categories: [],
        isRequired: true,
        isCollection: false,
        expectedType: {
            type: PrimitiveType.String,
        },
    },
    {
        name: 'IconName',
        displayName: 'Icon Name',
        order: 2,
        type: ParameterType.Primitive,
        typeCustom: ParameterTypes.IconName,
        description: 'Optional icon to display on the button',
        categories: [],
        isRequired: false,
        isCollection: false,
        expectedType: {
            type: PrimitiveType.String,
        },
    },
    {
        name: 'Type',
        displayName: 'Type',
        order: 3,
        type: ParameterType.Primitive,
        description: 'Action type (e.g., "submit", "cancel")',
        categories: [],
        isRequired: false,
        isCollection: false,
        expectedType: {
            type: PrimitiveType.String,
        },
    },
    {
        name: 'IsDefault',
        displayName: 'Is Default',
        order: 4,
        type: ParameterType.Primitive,
        description: 'Whether this action is the default action (shown as contained button)',
        categories: [],
        isRequired: false,
        defaultValue: false,
        isCollection: false,
        expectedType: {
            type: PrimitiveType.Boolean,
        },
    },
    {
        name: 'Path',
        displayName: 'Path',
        order: 5,
        type: ParameterType.Primitive,
        description: 'Navigation path when action is clicked',
        categories: [],
        isRequired: false,
        isCollection: false,
        expectedType: {
            type: PrimitiveType.String,
        },
    },
    {
        name: 'OnSelected',
        displayName: 'On Selected',
        order: 6,
        type: ParameterType.Expression,
        description: 'Expression to execute when the action is clicked',
        categories: [],
        isRequired: false,
        isCollection: false,
        expectedType: {}
    },
    {
        name: 'Disabled',
        displayName: 'Disabled',
        order: 100,
        type: ParameterType.Expression,
        description: 'Expression that determines if the action button is disabled',
        categories: [],
        isRequired: false,
        isCollection: false,
        expectedType: {
            type: PrimitiveType.Boolean,
        },
    },
    {
        name: 'DisabledTooltip',
        displayName: 'Disabled Tooltip',
        order: 101,
        type: ParameterType.Primitive,
        description: 'Tooltip text to show when the action is disabled',
        categories: [],
        isRequired: false,
        isCollection: false,
        expectedType: {
            type: PrimitiveType.String,
        },
    },
    // TODO: Add ConfirmationDialog parameter when we have a custom editor for it
];

export const DialogActionMetadata: ComponentMetadataModel = {
    name: 'DialogAction',
    displayName: 'Dialog Action',
    category: 'Virtual',
    categories: ['Virtual'],
    description: 'A button action in a dialog footer',
    parameters: DialogActionParameters,
    iconName: 'TouchApp',
    isContainer: false,
};
